import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import DocumentDialogForm from "./_DocumentDialogForm";
import AppDocuServiceCall from "../_Utils/AppDocuServiceCall";
import { notifySomething } from "../_Utils/AppDocuCommon";

export default class EditDocumentDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: null,
      loading: false,
      prevItemId: null,
    };
  }

  async componentDidMount() {
    if (this.props.itemId) {
      this.setState({ loading: true });
      try {
        const res = await AppDocuServiceCall.getDocument(this.props.itemId);
        const doc = res.data.document || {};
        await new Promise(resolve => setTimeout(resolve, 500)); // sleep 500ms
        this.setState({ itemData: doc, loading: false, prevItemId: this.props.itemId });
      } catch (e) {
        this.setState({ loading: false });
        notifySomething('Errore caricamento dati documento', 'error');
      }
    }
  }

  async componentDidUpdate(prevProps) {
    if (this.props.itemId && this.props.itemId !== prevProps.itemId) {
      this.setState({ loading: true });
      try {
        const res = await AppDocuServiceCall.getDocument(this.props.itemId);
        const doc = res.data.document || {};
        await new Promise(resolve => setTimeout(resolve, 500)); // sleep 500ms
        this.setState({ itemData: doc, loading: false, prevItemId: this.props.itemId });
      } catch (e) {
        this.setState({ loading: false });
        notifySomething('Errore caricamento dati documento', 'error');
      }
    }
    // Reset state if dialog is closed
    if (!this.props.itemId && prevProps.itemId) {
      this.setState({ itemData: null, loading: false, prevItemId: null });
    }
  }

  updateDocumentService = async (itemData) => {
    try {
      const res = await AppDocuServiceCall.updateDocument(itemData);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error updating document', 'error');
        return;
      }
      await this.props.onItemsChange();
      this.props.onClose();
    } catch (error) {
      console.error('Error updating document:', error);
      notifySomething('Error updating document', 'error');
    }
  };

  handleUpdate = async () => {
    const m = this.state.itemData || {};
    const data = {
      ...m,
      document_type: m.document_type !== undefined && m.document_type !== null ? m.document_type : '',
      name: m.name !== undefined && m.name !== null ? m.name : '',
      description: m.description !== undefined && m.description !== null ? m.description : '',
      language: m.language !== undefined && m.language !== null ? m.language : '',
      original_filename: m.original_filename !== undefined && m.original_filename !== null ? m.original_filename : '',
      com_brand: m.com_brand !== undefined && m.com_brand !== null ? m.com_brand : '',
    };
    await this.updateDocumentService(data);
  }

  render() {
    const { itemData, loading } = this.state;
    return (
      <>
      {loading || !itemData ? (
        <Dialog open={!!this.props.itemId} onClose={this.props.onClose} maxWidth="sm" fullWidth>
          <DialogTitle>Edit Document</DialogTitle>
          <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 120 }}>
              <CircularProgress size={40} thickness={4} />
            </div>
          </DialogContent>
        </Dialog>
      ) : (
        <Dialog open={!!this.props.itemId} onClose={this.props.onClose} maxWidth="sm" fullWidth>
          <DialogTitle>Edit Document</DialogTitle>
          <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
            <DocumentDialogForm
              itemData={itemData}
              onChange={newData => this.setState({ itemData: newData })}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose}>Cancel</Button>
            <Button onClick={this.handleUpdate} color="primary" disabled={loading || !itemData}>Update</Button>
          </DialogActions>
        </Dialog>
      )}
      </>
    );
  }
}
